import React from "react";

const AdminOrgsSkeleton: React.FC = () => (
  <div className="bg-white h-full flex flex-col overflow-hidden animate-pulse">
    <div className="w-full mx-auto pt-6 sm:pt-10 px-4 sm:px-6 lg:px-10 flex-shrink-0">
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 mb-6">
        <div>
          <div className="h-6 bg-gray-200 rounded w-40 mb-2" />
          <div className="h-4 bg-gray-200 rounded w-56" />
        </div>
        <div className="h-9 bg-gray-200 rounded-lg w-40" />
      </div>
    </div>
    <div className="flex-1 overflow-y-auto px-4 sm:px-6 lg:px-10 pb-10">
      <div className="h-4 bg-gray-200 rounded w-32 mb-4" />
      {/* search */}
      <div className="h-9 bg-gray-200 rounded-lg w-64 mb-4" />
      {/* table */}
      <div className="border border-gray-200 rounded-lg overflow-hidden">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-200">
              {[...Array(5)].map((_, i) => (
                <th key={i} className="px-4 py-3">
                  <div className="h-3 bg-gray-200 rounded w-14" />
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {[...Array(8)].map((_, i) => (
              <tr key={i}>
                <td className="px-4 py-3">
                  <div className="flex items-center gap-3">
                    <div className="h-7 w-7 bg-gray-200 rounded-full flex-shrink-0" />
                    <div className="h-4 bg-gray-200 rounded w-32" />
                  </div>
                </td>
                <td className="px-4 py-3 hidden sm:table-cell">
                  <div className="h-4 bg-gray-200 rounded w-8" />
                </td>
                <td className="px-4 py-3 hidden sm:table-cell">
                  <div className="h-4 bg-gray-200 rounded w-8" />
                </td>
                <td className="px-4 py-3 hidden sm:table-cell">
                  <div className="h-4 bg-gray-200 rounded w-10" />
                </td>
                <td className="px-4 py-3 hidden md:table-cell">
                  <div className="h-4 bg-gray-200 rounded w-24" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default AdminOrgsSkeleton;
